import { motion, Variants, Easing } from "framer-motion";
import facebookLogo from "../../Images/facebookLogo.svg";
import MapAPIImplementation from "../MapAPIImplementation";
import Section from "../Common/Section";
import Card from "../Common/Card";
import "./style.scss";

interface ContactUsProps {
  order?: "odd" | "even";
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" as Easing },
  },
};

const ContactUs: React.FC<ContactUsProps> = ({ order }) => {
  return (
    <Section variant={order} className="contactUs">
      <div className="sectionHeader">
        <motion.h1 className="title" variants={itemVariants}>
          Contact Us
        </motion.h1>
        <motion.p className="description" variants={itemVariants}>
          Based in Farnham, we serve the local and surrounding areas. Reach out
          for a free, no-obligation quotation or any service enquiries.
        </motion.p>
      </div>

      <motion.div className="contentGrid" variants={containerVariants}>
        <motion.div className="map" variants={itemVariants}>
          <MapAPIImplementation />
        </motion.div>

        <motion.div className="contactDetails" variants={containerVariants}>
          <Card className="infoCard" variants={itemVariants}>
            <span className="material-symbols-outlined icon">mail</span>
            <h3>Email</h3>
            <p>w.stewart76@btinternet.com</p>
          </Card>
          <Card className="infoCard" variants={itemVariants}>
            <span className="material-symbols-outlined icon">call</span>
            <h3>Phone</h3>
            <p>01252 726833</p>
          </Card>
          <motion.button
            className="facebookButton"
            onClick={() =>
              window.open(
                "https://www.facebook.com/profile.php?id=100054523986920",
              )
            }
            variants={itemVariants}
          >
            <img src={facebookLogo} alt="Facebook" />
            <span>Visit Facebook Page</span>
          </motion.button>
        </motion.div>
      </motion.div>
    </Section>
  );
};

export default ContactUs;
